export enum TreeTabs {
    VEHICLES = 'vehicles',
    DRIVER = 'driver',
}
